
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ThemeConstantService } from './services/theme-constant.service';
import { SearchPipe } from './pipes/search.pipe';
import {ItemCountComponent} from './components/item-count/item-count.component';
import {HasAnyAuthorityDirective} from './directives';
import {IconFilterPipe} from './pipes/iconFilter.pipe';
import { SearchFilterComponent } from 'src/app/shared/components/search-filter/search-filter.component';
import { ErrorTextComponent } from 'src/app/shared/components/error-text/error-text.component';
import { ConfirmPopUpComponent } from 'src/app/shared/components/confirm-popup/confirm-popup.component';
import { TransformCustomDatePipe } from 'src/app/shared/pipes/transformCustomDate.pipe';
import { DropdownSearchComponent } from './components/dropdown-search/dropdown-search.component';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule  } from 'ng-zorro-antd/select';
import { NzTableModule  } from 'ng-zorro-antd/table';
import { NzTabsModule  } from 'ng-zorro-antd/tabs';
import { NzAvatarModule  } from 'ng-zorro-antd/avatar';
import { NzAlertModule  } from 'ng-zorro-antd/alert';
import { NzProgressModule  } from 'ng-zorro-antd/progress';
import { NzToolTipModule   } from 'ng-zorro-antd/tooltip';
import { NzPopoverModule    } from 'ng-zorro-antd/popover';
import { NzSwitchModule   } from 'ng-zorro-antd/switch';
import { OTPComponent } from './components/otp/otp.component';
import { InputNumberComponent } from './components/input-number/input-number';
import { InputDateComponent } from './components/input-date/input-date';
import { TransformMoneyPipe } from './pipes/transformMoney.pipe';
import { DocumentsComponent } from './components/documents/documents';
import { InputValueRangeComponent } from './components/input-value-range/input-value-range.component';
import { InputDatePickerAndTimeComponent } from './components/input-datepicker-and-time/input-datepicker-and-time';
import { FilterStartEndDateComponent } from './components/filter-start-end-date/filter-start-end-date';
import { UserAuthorityDirective } from '../../app/shared/directives/user-authority.directive';
import { AccountTypeDirective } from '../../app/shared/directives/check.account.type.directive';
import { FileUploadModule } from 'ng2-file-upload';

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FileUploadModule,
        NzIconModule,
        NzTagModule,
        NzBadgeModule,
        NzModalModule,
        NzCardModule,
        NzTabsModule,
        NzListModule,
        NzPageHeaderModule,
        NzFormModule,
        NzLayoutModule,
        NzDropDownModule,
        NzButtonModule,
        NzSelectModule,
        NzTableModule,
        NzAvatarModule,
        NzInputModule,
        NzAlertModule,
        NzPaginationModule,
        NzProgressModule,
        NzToolTipModule,
        NzPopoverModule,
        NzSwitchModule,
        NzDividerModule
    ],
    declarations: [
        IconFilterPipe,
        SearchPipe,
        ItemCountComponent,
        ErrorTextComponent,
        HasAnyAuthorityDirective,
        SearchFilterComponent,
        ConfirmPopUpComponent,
        TransformCustomDatePipe,
        TransformMoneyPipe,
        DropdownSearchComponent,
        InputNumberComponent,
        InputDateComponent,
        DocumentsComponent,
        InputValueRangeComponent,
        InputDatePickerAndTimeComponent,
        FilterStartEndDateComponent,
        UserAuthorityDirective,
        AccountTypeDirective,
        OTPComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        FileUploadModule,
        ReactiveFormsModule,
        NzBadgeModule,
        IconFilterPipe,
        NzTagModule,
        NzPaginationModule,
        NzModalModule,
        NzInputModule,
        NzIconModule,
        NzPageHeaderModule,
        NzTabsModule,
        NzDividerModule,
        NzCardModule,
        NzListModule,
        NzFormModule,
        NzLayoutModule,
        NzDropDownModule,
        NzButtonModule,
        NzSelectModule,
        NzTableModule,
        NzAvatarModule,
        NzInputModule,
        NzAlertModule,
        NzProgressModule,
        NzSwitchModule,
        NzToolTipModule,
        NzPopoverModule,
        SearchPipe,
        HasAnyAuthorityDirective,
        SearchFilterComponent,
        ErrorTextComponent,
        DropdownSearchComponent,
        OTPComponent,
        InputNumberComponent,
        InputDateComponent,
        TransformMoneyPipe,
        DocumentsComponent,
        InputValueRangeComponent,
        InputDatePickerAndTimeComponent,
        FilterStartEndDateComponent,
        UserAuthorityDirective,
        AccountTypeDirective,
        TransformCustomDatePipe
    ],
   
    providers: [
        ThemeConstantService
    ]
})

export class SharedModule { }
